import { Component, OnInit, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { IMyDateModel } from 'angular-mydatepicker';


import { PaymentService } from '../_services/payment-service.service';

import { PurchaseDetailsModalComponent } from './purchase-details-modal.component';
import { getUrl } from '../_shared/utils';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DialogService } from '../_services/dialog.service';
import { startDateBeforeEndDate } from '../_services/date-picker-validator.service';

@Component({
    selector: 'app-payment-history',
    templateUrl: './payment-history.component.html',
    styleUrls: ['./payment-history.component.css'],
    encapsulation: ViewEncapsulation.None
})

export class PaymentHistoryComponent implements OnInit {

    // Environment Variables
    baseUrl = getUrl();

    loading = false;
    disabled = false;
    editing = {};
    purchases = [];
    filteredPurchases = [];
    displayIncomplete = false;
    display = [];
    searchText = '';

    private bsModalRef: BsModalRef;
    public form: FormGroup;
    private _onDestroy$: Subject<void> = new Subject();

    constructor(
        private paymentService: PaymentService,
        private modalService: BsModalService,
        private fb: FormBuilder,
        private viewRef: ViewContainerRef,
        private dialogService: DialogService) { }

    ngOnInit() {
        this.loadPurchases();

        this.form = this.fb.group({
            period: [{ startDate: new Date(), endDate: new Date(), isNew: false }, startDateBeforeEndDate()]
          });

          this.form.controls.period.patchValue({
            startDate: new Date('01/01/2015'),
            endDate: new Date()
          });

        this.form.controls.period.valueChanges.pipe(takeUntil(this._onDestroy$)).subscribe(() => {
            this.filterPurchases();
          });
    }

    loadPurchases() {
        this.loading = true;
        this.paymentService.getPurchases().subscribe(data => {
            this.filteredPurchases = [];
            data.forEach(element => {
                if (element.purchaseComplete) {
                    this.filteredPurchases.push(element);
                }
            });
            this.display = this.filteredPurchases;
            this.purchases = data;
            this.loading = false;
        });
    }

    refundPurchase(purchaseId: number) {
        this.dialogService.confirm('Confirm Refund', 'Are you REALLY sure you want to refund this purchase?', this.viewRef).then(result => {
          if (result) {
            this.loading = true;
            this.paymentService.refundPurchase(purchaseId).subscribe(
              () => {
                this.loadPurchases();
              },
              () => {
                this.dialogService.alert('Error', 'Unable to refund this purchase', this.viewRef);
                this.loading = false;
              }
            );
          }
        });
      }

    filterPurchases() {
        let temp: any[] = this.purchases;
        if (this.displayIncomplete) {
            temp = this.purchases;
        } else {
            temp = this.filteredPurchases;
        }

        if (this.searchText != null && this.searchText !== '') {
            temp = temp.filter(
                p => (p.userEmail != null ? p.userEmail.toLowerCase().indexOf(this.searchText.toLowerCase()) >= 0 : false) || (p.description != null ? p.description.toLowerCase().indexOf(this.searchText.toLowerCase()) >= 0 : false));
        }


        temp = temp.filter(p => Date.parse(p.datePurchased) > Date.parse(`${this.formatDate(this.form.controls.period.value.startDate)}`));
        temp = temp.filter(p => Date.parse(p.datePurchased) < Date.parse(`${this.formatDate(this.form.controls.period.value.endDate)}`));

        this.display = temp;
    }

    generatePurchaseReport() {
        this.loading = true;
        const reportParameters = {
            startDate: this.form.controls.period.value.startDate.formatted,
            endDate: this.form.controls.period.value.endDate.formatted,
            filterText: this.searchText,
            displayIncomplete: this.displayIncomplete
        };

        this.paymentService.generateReport(reportParameters).subscribe(() => {
            this.loading = false;
        });
    }

    public openPurchaseDetails(purchase: any) {
      const modalConfig = {
        backdrop: true,
        ignoreBackdropClick: true
      };

      const initialState = {
        purchase: purchase
      };

      this.bsModalRef = this.modalService
        .show(
          PurchaseDetailsModalComponent,
          Object.assign({}, modalConfig, { class: 'modal-md', initialState }));
    }

    private formatDate(date: Date): string {
        return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
      }




}
